export function setUser(state, user) {
    state.user = user;
    localStorage.setItem('user', JSON.stringify(user));
    var today = new Date();
    state.date = today.toISOString().substring(0, 10);
}

export function setTokenDevice(state, tokendevice) {
    state.token_device = tokendevice
}

export function setShowMenu(state, _show) {
    state.showMenu = _show
}

export function setAccessToken(state, accesstoken) {
    state.isLogged = true
    state.error = false
    state.errorMessage = ''
    state.access_token = accesstoken
    localStorage.setItem('access_token', accesstoken);
}

export function setRutaDocumentosPresupuestos(state, rutaDocumentosPresupuestos) {
    state.rutaDocumentosPresupuestos = rutaDocumentosPresupuestos
}

export function setRutaDocumentosConfirmaciones(state, rutaDocumentosConfirmaciones) {
    state.rutaDocumentosConfirmaciones = rutaDocumentosConfirmaciones
}

export function setRutaDocumentosContratos(state, rutaDocumentosContratos) {
    state.rutaDocumentosContratos = rutaDocumentosContratos
}

export function setRutaDocumentosFacturas(state, rutaDocumentosFacturas) {
    state.rutaDocumentosFacturas = rutaDocumentosFacturas
}

export function logout(state, res) {
    console.log('logout', res);
    state.user = null;
    localStorage.removeItem('user');
    state.globales = []
    state.date = null
    state.isLogged = false
    state.error = false
    state.errorMessage = ''
    state.access_token = ''
    localStorage.removeItem('access_token');
}

export function authError(state, error) {
    state.error = true
    state.errorMessage = error
    state.user = null
    state.globales = []
    state.isLogged = false
}
